module.exports = function() {

    /**
     * Buttons && Modals
     */
    var $addPropertyViewingButton = $('#js-add-property-viewing-of-property'),
        $addPropertyViewingModal = $('#add-property-viewing-of-property');

 //   $editPropertyViewingButton = $('#js-edit-property-viewing-of-property');

    /**
     * Controllers
     */
    var PropertyViewingOfPropertyDataTable = new (require('./PropertyViewingOfPropertyDataTable'))(),
        PropertyViewingCalendarOfPropertyController = new (require('./PropertyViewingCalendarOfPropertyController'))(PropertyViewingOfPropertyDataTable),
        AddPropertyViewingController = new (require('./PropertyViewingController'))($addPropertyViewingModal, PropertyViewingCalendarOfPropertyController);


   PropertyViewingCalendarOfPropertyController.render();

    // Let show modal on button click
    $addPropertyViewingButton.click(function(e){
        AddPropertyViewingController.showModal();
        e.preventDefault();
    });

    // Let get viewing and show modal on button click
    //$editPropertyViewingButton.click(function(e){
    //    EditPropertyViewingController.getModel();
    //    EditPropertyViewingController.showModal();
    //    e.preventDefault();
    //});

}();